import useMap from "../utils/useMap";
import { ATTRIBUTE_PREFIX } from "./enum";


/**
 * 
 * @param {string} html 
 * @returns {NodeList}
 */
export const htmlToNodes = (html) => {
    const parser = new DOMParser().parseFromString(html, 'text/html');
    return parser.body.childNodes;
}

export const parseHTML = (html, seriazble) => {
    return typeof html === 'string' ? new DOMParser().parseFromString(html, 'text/html').body.firstChild : html;
}
/**
 * 
 * @param {Node} node 
 * @returns 
 */
export const queryAllChilds = (node) => {
    if (!node.querySelectorAll) {
        return [];
    }
    return Array.from(node.querySelectorAll('*'));
}


/**
 * 
 * @param {Node} node 
 * @returns {Array<Node>}
 */
export const lookupChildNodes = (node) => {
    if (!(node instanceof HTMLElement) || node.childNodes.length === 0) return [];
    let childNodes = [];
    for (let i in node.childNodes) {
        if (!(node.childNodes[i] instanceof Node)) continue;
        childNodes.push(node.childNodes[i]);
        const subChilds = lookupChildNodes(node.childNodes[i]);
        if (subChilds.length > 0) {
            childNodes = childNodes.concat(subChilds);
        }
    }
    return childNodes;
}

/**
 * 
 * @param {Node | Element} node 
 * @returns { Object.<string, string>}
 */
export const extractAttributeFromNode = (node) => {
    const attributes = node.attributes;
    const rs = {};
    const arr = Array.from(attributes);
    for (let i in arr) {
        const key = arr[i].name;
        rs[key] = attributes[i].textContent;
    }
    return rs;
}


const convertRegExpClause = (() => {

    const specialCase = useMap();
    specialCase.set('(', '\\(');
    specialCase.set(')', '\\)')

    return (openTag = '', closeTag = '') => {
        openTag = specialCase.get(openTag) || openTag;
        closeTag = specialCase.get(closeTag) || closeTag;
        return `${openTag}(.*?)${closeTag}`;
    };
})();

/**
 * 
 * @param {string} text 
* @returns {[[searchText:string, searchTextWithoutTag:string]]} 
 */
export const extractContentByTag = (text, openTag = '{{', closeTag = '}}') => {
    // Regular expression to find text between {{ and }}
    // const regex = /{{(.*?)}}/g;F
    const clause = convertRegExpClause(openTag, closeTag);
    const regex = new RegExp(clause, 'g')
    const matches = text.match(regex) || [];
    const openLength = openTag.length, closeLength = -closeTag.length;
    const results = matches.map(match => {
        return [match, match.slice(openLength, closeLength).trim()]
    });
    return results;
}


/**
 *
 * @param {string} text
 * @returns {string}
 */
export const convertToPropAccessByBracket = (text) => {
    const rs = text.split('.').reduce((out, current) => {
        return out + `.${current}`;
    }, '');
    return rs;
}

export const getAttributeName = (name) => `${ATTRIBUTE_PREFIX}:${name}`

export const replaceSpecialChars = (str, replacement,) => {
    // Define the regular expression to match special characters
    const regex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/g;

    // Replace matched special characters with the replacement string
    return str.replace(regex, replacement);
}

/**
 * 
 * @param {Object} props 
 * @param {str} key 
 * @returns {boolean}
 */
export const isPropContainKey = (props, key) => {
    return props.hasOwnProperty(key);
}

export const isStringContainChar = (str, ...chars) => {
    for (let i in chars) {
        if (str.includes(chars[i])) return true;
    }
    return false;
}

export const copyDeep = (obj) => {
    return obj;
}


export const isMethodCalling = (str) => {
    // Regex pattern to match a method call
    // The pattern assumes method calls like object.method() or object.method(arg1, arg2, ...)
    const methodCallPattern = /^[a-zA-Z_$][\w$]*\s*\([^)]*\);?$/
    return methodCallPattern.test(str.trim());
}

export const isArrayByString = (str) => {

}



/**
 * @param {string} str
 * @returns {Array<string>}
 *  */
export const extractMethodArgument = (str = '') => {
    const arr = extractContentByTag(str, "(", ")");
    if (arr.length > 0) {
        const [searchText, searchTextWithoutTag] = arr[0];
        return searchTextWithoutTag.split(',');
    }
    return [];
}

export const extractMethodName = (str = '') => {
    const split = str.split('(');
    if (split.length > 1) {
        return split[0];
    }
    return str;
}